<template>
  <div class="table-manage-box">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="screen">
          <p>订单状态：</p>
          <p>{{ typeMap[afterSale.afterType] }}</p>
        </div>
        <div class="sub_txt">
          <div class="main_txt">售后说明</div>
          <div class="txt">
            售后原因：
            <p v-text="afterSale.afterReason"></p>
          </div>
          <div class="txt">
            售后说明：
            <p v-text="afterSale.afterRemark"></p>
          </div>
          <div class="txt img-box">
            售后图片：
            <el-image style="width: 100px; height: 100px;margin-right: 6px;"
              v-for="(item, index) in afterSale.afterProof" :key="index" :src="item" fit="cover" :preview-src-list="afterSale.afterProof"></el-image>
          </div>
        </div>
        <!-- <div class="sub_txt" v-if="logisticList.length">
          <div class="main_txt">物流信息</div>
          <div
            v-for="(logistic, index) in logisticList"
            :key="logistic.id"
            :style="{ marginTop: index > 0 ? '40px' : '0px' }"
          >
            <div class="txt">发货日期：{{ main.deliverTime || "无" }}</div>
            <div class="txt">物流公司：{{ logistic.company }}</div>
            <div class="txt">运单编号：{{ logistic.code }}</div>
          </div>
        </div> -->
        <div class="sub_txt" v-if="afterSale.afterType === 3">
          <div class="main_txt">退货信息</div>
          <div class="horizontal">
            <div class="vertical order-detail">
              <div class="txt">
                物流公司：
                <p v-text="afterSale.goodsReturnCompany"></p>
              </div>
              <div class="txt">
                物流单号：
                <p v-text="afterSale.goodsReturnCode || '无'"></p>
              </div>
            </div>
            <!-- <div style="flex: 1">
              <div class="txt">
                收货人：
                <p v-text="main.created"></p>
              </div>
              <div class="txt">
                电话：
                <p v-text="main.created"></p>
              </div>
              <div class="txt">
                地址：
                <p v-text="main.created"></p>
              </div>
            </div> -->
          </div>
        </div>
        <div class="sub_txt">
          <div class="main_txt">订单详情</div>
          <div class="horizontal">
            <div class="vertical order-detail">
              <div class="txt">
                购买人：
                <p v-text="orderInfo.name"></p>
              </div>
              <div class="txt">
                用户ID：
                <p v-text="afterSale.uid"></p>
              </div>
              <!-- <div class="txt">
                用户身份：
                <p>{{ main.role }}</p>
              </div> -->
              <div class="txt">
                联系电话：
                <p v-text="orderInfo.phone"></p>
              </div>
              <div class="txt">
                收货地址：
                <p>
                  {{ orderInfo.provinceStr + orderInfo.cityStr + orderInfo.countyStr + orderInfo.address }}
                </p>
              </div>
              <div class="txt">
                买家留言：
                <p v-text="orderInfo.remark || '无'"></p>
              </div>
              <div class="txt">
                订单编号：
                <p v-text="orderInfo.oid"></p>
              </div>
            </div>
            <div style="flex: 1">
              <!-- <div class="txt">
                支付方式：
                <p v-text="payModeName"></p>
              </div> -->
              <div class="txt">
                下单时间：
                <p v-text="afterSale.orderCreated"></p>
              </div>
              <!-- <div class="txt" v-if="[8, 16, 18].includes(main.status)">
                付款时间：
                <p v-text="main.payTime"></p>
              </div> -->
              <!-- <div class="txt" v-if="[8, 16, 18].includes(main.status)">
                支付方式：
                <p v-text="main.payTime"></p>
              </div> -->
              <!-- <div class="txt" v-if="[16, 18].includes(main.status)">
                发货时间：
                <p v-text="main.deliverTime"></p>
              </div>
              <div class="txt" v-if="[18].includes(main.status)">
                收货时间：
                <p v-text="main.confirmTime"></p>
              </div> -->
              <div class="txt">
                售后时间：
                <p v-text="afterSale.created"></p>
              </div>
            </div>
          </div>
          <div class="vertical sub_txt1">
            <el-table :data="skuList" class="order-table table no-border-table" id="table" ref="multipleTable"
              :header-cell-style="{
                border: 'none',
                color: '#333',
                background: '#f6f6f6',
                borderBottom: '1px solid #E8E8E8',
                height: '54px',
              }" :row-style="{
  height: '54px',
}">
              <el-table-column prop="id" label="序号">
                <template slot-scope="scope">
                  <p>{{ scope.$index + 1 }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="user" label="商品主图">
                <template slot-scope="scope">
                  <img :src="scope.row.masterPic" />
                </template>
              </el-table-column>
              <el-table-column prop="name" label="商品名称"> </el-table-column>
              <el-table-column prop="attrs" label="规格">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.attrs" :key="index">
                    <p>{{ item.keyName }}：{{ item.value }};</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="价格"> </el-table-column>
              <el-table-column prop="num" label="数量"> </el-table-column>
            </el-table>
            <div class="horizontal price">
              <div class="color_red">退款金额：¥ {{ afterSale.amount }}</div>
            </div>
          </div>
        </div>
        <div class="sub_txt">
          <div class="main_txt">协商历史</div>
          <div class="history">
            <el-timeline>
              <el-timeline-item v-for="(activity) in histories" :key="activity.id" :timestamp="activity.created">
                {{ activity.content }}
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="refundShow" class="dialog" width="618px" top="25vh">
      <div slot="title" class="dialog-title">修改退款金额</div>
      <el-form ref="form" :model="refundForm" class="refund-form" label-width="auto">
        <el-form-item label="退款金额：" prop="oid" class="form-item">
          <input placeholder="输入退款金额" class="input" v-model.number="refundForm.amount" size="small"
            placeholder-class="placeholder" onkeypress="/([0-9]|\.)/.test(event.key)"
            oninput="value = /^\d+(\.{1}\d{0,2})?/g.exec(value) ? /^\d+(\.{1}\d{0,2})?/g.exec(value)[0] : ''" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="refundShow = false">取 消</el-button>
        <el-button class="confirm-btn btn" @click="handlerefund">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
// let that;
export default {
  name: 'orderDetail',
  components: { Header },
  data() {
    return {
      title: {
        // 页面标题
        firstTitile: '订单管理',
        secondTitle: '订单详情'
      },
      statusMap: {
        2: '待支付',
        8: '待发货',
        16: '待收货',
        18: '已收货',
        20: '售后中',
        22: '售后完成'
      },
      typeList: {},
      statusList: [], // 状态列表
      address: {},
      integral: {},
      logisticList: [],
      logistic: {},
      main: {},
      skuList: [],
      afterSale: {},
      orderInfo: {},
      histories: [],
      typeMap: {
        2: '仅退款',
        3: '退货退款'
      },
      content: '',
      refundForm: {
        amount: null
      },
      refundShow: false
    };
  },
  filters: {},
  async created() {
    // that = this;
    this.type = +this.$route.query.type;
    this.getOrderInfo();
  },
  methods: {
    getOrderInfo() {
      this.isLoading = true;
      this.httpPost(this.$root.afterSaleInfo, {
        id: +this.$route.query.id
      }).then(
        (res) => {
          this.afterSale = res.afterSale;
          this.orderInfo = res.orderInfo;
          this.histories = res.histories;
          this.skuList = res.skuList;
          // this.payModeName = res.payModeName;
          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
        }
      );
    },
    getAddress() {
      return (
        this.address.provinceStr +
        this.address.cityStr +
        this.address.countyStr +
        this.address.address
      );
    },
    updateStatus() {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定当前售后申请通过？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.agreeAfterSale, {
          id: this.afterSale.id
          // status
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getOrderInfo();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    updateStatus2() {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定当前售后申请驳回？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.rejectAfterSale, {
          id: this.afterSale.id
          // status
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getOrderInfo();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    updateStatus3() {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定当前售后订单通过退款？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPost(this.$root.agreeAfterSale2, {
          id: this.afterSale.id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getOrderInfo();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    updateStatus4() {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定当前售后订单驳回退款？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.rejectAfterSale2, {
          id: this.afterSale.id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getOrderInfo();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    handleSend() {
      this.loading++;
      this.httpPost(this.$root.sendHistory, {
        aid: this.afterSale.id,
        content: this.content
      }).then(
        (res) => {
          this.$message({
            message: '发送成功',
            type: 'success'
          });
          this.loading--;
          this.content = '';
          this.getOrderInfo();
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    refundModal() {
      this.serviceDetail = {};
      this.refundForm = {
        amount: null,
      };
      this.$refs.form && this.$refs.form.clearValidate();
      this.refundShow = true;
    },
    handlerefund() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading++;
          this.httpPut(this.$root.changeAfterSaleAmount, { ...this.refundForm, id: this.afterSale.id }).then(
            (res) => {
              this.loading--;
              this.refundShow = false;
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getOrderInfo();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.table-manage-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;
}

.container {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  flex-y(flex-start, flex-start);
  padding: 0 24px;

  // content 表格
  .content {
    width: 100%;
    font-size: 14px;
    box-sizing: border-box;
    border-radius: 2px;
    flex-y(flex-start, flex-start);
    background: #f5f5f5;
    .service-bottom{
      width: 100%;
      flex-x(center);
      padding-top: 16px;
    }
    .service-btn{
      display: inline-block;
      confirm-btn();
      width: 72px;
      height: 32px;
      line-height: 32px;
      margin: 0 12px;
    }
  }
}

.screen {
  width: calc(100% - 30px);
  background: white;
  padding: 30px 15px;
  flex-x(flex-start);
  margin-top: 0;
  margin-bottom: margin10;

  .el-input {
    width: 300px;
    margin: 0 margin10;
  }

  p {
    word(14px, btn-color);
  }
}

.el-table {
  width: calc(100% - 10px) !important;
  margin-top: 10px;
  border();
  font-size: 12px;

  img {
    width: 60px;
    height: 60px;
  }

  .el-icon-star-on {
    color: yellow;
  }
}

.footer {
  width: calc(100% - 30px);
  min-width: 600px;
  padding: 10px 0 0 15px;
  flex-x();

  .el-button {
    margin-left: 10px;
  }
}

.divider {
  background-color: bk;
  width: 100%;
  height: 2px;
  margin: 10px 0;
}

.vertical {
  flex-y();
}

.horizontal {
  flex-x(flex-start, flex-start);
}

.order-detail {
  flex: 1;
  justify-content: flex-start;
  align-items: flex-start;
  min-height: 80px;
}

.sku {
  height: 45px;
  justify-content: space-around;
  min-width: 900px;
  border-bottom: solid 1px #dddddd;
}

.price {
  align-self: flex-end;
  height: 30px;
  margin-right: 30px;
  margin-top: 10px;

  div {
    margin-left: 15px;
  }
}

.sub_txt {
  color: #666666;
  font-size: 14px;
  width: 100%;
  padding: 25px 15px 10px;
  background: white;
  margin-bottom: 10px;
}

.sub_txt1 {
  color: #666666;
  font-size: 14px;
  width: 1000px;
  padding-left: 60px;
}

.main_txt {
  color: #101010;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}

.color_red {
  color: btn-color;
}

.history{
  padding: 12px 24px 0;
}

.input-box{
  flex-x(flex-start);
  padding: 0 24px;
  .input{
    width: 60%;
    height: 58px;
    border: 1px solid #E5E5E5;
    padding: 0 20px;
  }
  .btn{
    height: 60px;
    width: 160px;
    background: #4876FF;
    word(16px, #fff);
    flex-x(center);
    cursor: pointer;
  }
}

.refund-form {
    padding: 16px 0 16px 120px;

    .input {
      width: 220px;
      height: 32px;
      line-height: 32px;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      padding: 0 15px;
      color: gray9;

      &::placeholder {
        /* WebKit browsers */
        color: #ccc;
      }
    }

    .search-btn {
      display: inline-block;
      confirm-btn();
      width: 72px;
      height: 32px;
      line-height: 32px;
      margin: 0 12px;
    }
  }

.txt {
  flex-x();
  justify-content: flex-start;
  margin: 3px;
  line-height: 2;
  padding-left: 60px;

  &.img-box {
    align-items: flex-start;
  }
}
</style>